/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* --------------------------------------------------------------------------
     Collection infinite scroll (progressive enhancement)

     Auto-loads the next page of products as the shopper approaches the bottom
     of the grid, appending them in place. The theme's numbered pagination is
     kept in the DOM (hidden) so it still works when JavaScript is unavailable,
     and it is restored if a fetch fails. Respects any active filters/sort,
     because the "next" URL is read from the rendered pagination each time.
     -------------------------------------------------------------------------- */
  function initCollectionInfiniteScroll() {
    // Bail out gracefully (leaving numbered pagination in place) when unsupported.
    if (!('fetch' in window)) return;

    var section = document.querySelector('[data-section-type="collection"]');
    if (!section) return;

    var productsGrid = section.querySelector('[data-products-grid]'); // .grid-outer
    if (!productsGrid) return;
    if (!productsGrid.querySelector('#CollectionLoop')) return;

    // Shopify Section Rendering API id: lets us fetch just this section instead
    // of the whole page (which carries heavy landing/hero/footer markup), so
    // each page load transfers and parses far less.
    var sectionId = section.getAttribute('data-section-id');
    function fetchUrl(url) {
      if (!sectionId) return url;
      try {
        var u = new URL(url, location.origin);
        u.searchParams.set('section_id', sectionId);
        return u.pathname + u.search;
      } catch (e) { return url; }
    }

    // A page loads when the grid's bottom edge comes within this many px of the
    // viewport bottom. Products have a fixed aspect ratio (real height even
    // before their image loads), so one appended page always pushes the grid
    // bottom well past this zone — pages load one at a time as the shopper
    // scrolls, never several at once.
    var TRIGGER_MARGIN = 300;

    function paginationEl() {
      return productsGrid.querySelector('.pagination-custom');
    }

    // The next-page URL, read from the rendered pagination so it reflects the
    // current filters/sort. Returns null on the last page.
    function readNextUrl() {
      var link = productsGrid.querySelector('.pagination-custom__next[href]');
      return link ? link.getAttribute('href') : null;
    }

    // Hide numbered pagination while JS drives the grid. Kept in the DOM as the
    // no-JS fallback and as the source of the next-page URL.
    function hidePagination() {
      var pagination = paginationEl();
      if (pagination) pagination.style.display = 'none';
    }
    function showPagination() {
      var pagination = paginationEl();
      if (pagination) pagination.style.display = '';
    }

    var nextUrl = readNextUrl();
    var loading = false;
    var stopped = false;       // set on fetch error to fall back to numbered pagination
    var armed = true;          // false between entering the trigger zone and leaving it
    var appendedPages = 0;     // how many extra pages are currently appended
    var restoring = false;     // true while replaying pages for back/forward restore

    hidePagination();

    // Measure the bottom edge of the product grid itself rather than a separate
    // sentinel element: the grid is plain block flow, so its bottom always
    // tracks the last product, and re-querying it each time survives the grid
    // re-render the theme performs on filter/sort. (A sentinel appended near the
    // grid landed in the sidebar's flex layout and reported the wrong position.)
    function nearBottom() {
      var loop = productsGrid.querySelector('#CollectionLoop');
      if (!loop) return false;
      return loop.getBoundingClientRect().bottom <= window.innerHeight + TRIGGER_MARGIN;
    }

    function loadMore() {
      if (loading || stopped || !nextUrl) return;

      loading = true;

      fetch(fetchUrl(nextUrl), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(response) {
          if (!response.ok) throw new Error('Request failed: ' + response.status);
          return response.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newLoop = doc.querySelector('#CollectionLoop');
          var currentLoop = productsGrid.querySelector('#CollectionLoop');

          if (newLoop && currentLoop) {
            // Move the fetched grid children (products + promo blocks) into place.
            // The theme's body MutationObserver picks up their [data-aos] elements
            // and animates them in, so no manual re-init is needed. Product images
            // are lazy-loaded by the theme, so off-screen pages fetch no images
            // until the shopper scrolls them into view.
            var fragment = document.createDocumentFragment();
            while (newLoop.firstChild) {
              fragment.appendChild(newLoop.firstChild);
            }
            currentLoop.appendChild(fragment);
            appendedPages++;
          }

          // Advance to the following page (null once the last page is loaded),
          // reading from the fetched document without touching our own DOM.
          var newNextLink = doc.querySelector('.pagination-custom__next[href]');
          nextUrl = newNextLink ? newNextLink.getAttribute('href') : null;
        })
        .catch(function() {
          // Restore numbered pagination so the shopper can still page manually.
          showPagination();
          stopped = true;
        })
        .then(function() {
          loading = false;
          // Re-check once the new layout has settled. The appended page pushes
          // the grid bottom past the trigger zone, which re-arms the gate; the
          // next page then waits for the shopper to scroll down to it.
          requestAnimationFrame(scheduleCheck);
        });
    }

    // One load per approach to the bottom: fire when the grid bottom enters the
    // trigger zone, then disarm until it leaves the zone again (which happens as
    // soon as a real-height page is appended). This mirrors an
    // IntersectionObserver's enter/exit transitions but via polling, so it can't
    // get stuck on a missed transition, nor load several pages during one long
    // scroll.
    function check() {
      if (restoring || stopped || !nextUrl) return;
      if (nearBottom()) {
        if (armed && !loading) {
          armed = false;
          loadMore();
        }
      } else {
        armed = true;
      }
    }

    // rAF-throttled scroll/resize handler.
    var ticking = false;
    function scheduleCheck() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        ticking = false;
        check();
      });
    }

    window.addEventListener('scroll', scheduleCheck, { passive: true });
    window.addEventListener('resize', scheduleCheck, { passive: true });

    // When the theme replaces the grid (filter/sort resets to page 1), re-read
    // the next URL and re-hide the fresh pagination. subtree:false means our own
    // appends into #CollectionLoop don't fire this.
    var gridObserver = new MutationObserver(function() {
      hidePagination();
      nextUrl = readNextUrl();
      stopped = false;
      armed = true;
      appendedPages = 0; // filtered/sorted view starts again at page 1
      scheduleCheck();
    });
    gridObserver.observe(productsGrid, { childList: true, subtree: false });

    /* ----------------------------------------------------------------------
       Scroll-position restoration on back/forward navigation.

       With infinite scroll, a shopper who opens a product from page 3 and hits
       Back would return to a grid rendered with only page 1 — the product they
       were viewing isn't in the DOM. On leaving we remember how many pages were
       appended and the scroll position (keyed by the collection URL); on a
       back/forward navigation we replay those page loads, then jump back to the
       saved position. Products reserve their height (aspect ratio) and load in
       the same order, so the layout matches and they land on the same product.
       When the browser's bfcache restores the page wholesale, none of this runs.
       ---------------------------------------------------------------------- */
    function stateKey() {
      return 'mb:collection-scroll:' + location.pathname + location.search;
    }
    function saveState() {
      // Don't overwrite the good state while a restore is still replaying pages
      // or settling its scroll (the grid is momentarily back near the top).
      if (restoring) return;
      try {
        sessionStorage.setItem(stateKey(), JSON.stringify({ pages: appendedPages, y: Math.round(window.scrollY) }));
      } catch (e) { /* storage unavailable/full */ }
    }
    function readState() {
      try { return JSON.parse(sessionStorage.getItem(stateKey())); } catch (e) { return null; }
    }
    function clearState() {
      try { sessionStorage.removeItem(stateKey()); } catch (e) { /* noop */ }
    }

    function isBackForward() {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type === 'back_forward';
      return performance.navigation && performance.navigation.type === 2; // legacy fallback
    }

    // Replay the previously-loaded pages, then jump to the saved scroll
    // position. Pages are fetched in parallel (not one-after-another) so the
    // wait is one round-trip, not several — the shopper isn't left sitting at
    // the top while pages load in sequence.
    function restore(count, y) {
      var pages = Math.min(count, 50); // hard cap as a runaway guard

      function finish() {
        // Jump now, and again after the next frame once layout has settled, so
        // the position sticks whether or not images have finished decoding.
        // Stay "restoring" until the scroll lands so a pagehide mid-restore
        // can't overwrite the saved position with the momentary top-of-page.
        window.scrollTo(0, y);
        requestAnimationFrame(function() {
          window.scrollTo(0, y);
          restoring = false;
          scheduleCheck();
        });
        // Safety net: never stay blocked if the frame callback is throttled.
        setTimeout(function() { restoring = false; }, 1000);
      }

      // Build the page URLs (2..N) from the current collection URL so they carry
      // any active filters/sort; fetch them all at once.
      var requests = [];
      for (var i = 2; i <= pages + 1; i++) {
        var url;
        try {
          var u = new URL(location.href);
          u.searchParams.set('page', i);
          url = u.pathname + u.search;
        } catch (e) { url = location.pathname + '?page=' + i; }
        requests.push(
          fetch(fetchUrl(url), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function(r) { return r.ok ? r.text() : ''; })
            .catch(function() { return ''; })
        );
      }

      Promise.all(requests).then(function(htmls) {
        var currentLoop = productsGrid.querySelector('#CollectionLoop');
        var lastDoc = null;
        // Append in page order so products stay in sequence.
        htmls.forEach(function(html) {
          if (!html || !currentLoop) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newLoop = doc.querySelector('#CollectionLoop');
          if (newLoop && newLoop.children.length) {
            var fragment = document.createDocumentFragment();
            while (newLoop.firstChild) fragment.appendChild(newLoop.firstChild);
            currentLoop.appendChild(fragment);
            appendedPages++;
            lastDoc = doc;
          }
        });
        // Continue infinite scroll from the last page we restored.
        if (lastDoc) {
          var link = lastDoc.querySelector('.pagination-custom__next[href]');
          nextUrl = link ? link.getAttribute('href') : null;
        }
        finish();
      }).catch(finish);
    }

    // Manage scroll ourselves so the browser doesn't jump to a stale position
    // before the extra pages exist.
    if ('scrollRestoration' in history) {
      try { history.scrollRestoration = 'manual'; } catch (e) { /* noop */ }
    }

    window.addEventListener('pagehide', saveState);

    var saved = isBackForward() ? readState() : null;
    if (saved && saved.pages > 0) {
      restoring = true;
      restore(saved.pages, saved.y || 0);
    } else {
      if (saved) window.scrollTo(0, saved.y || 0); // returned, but no extra pages had loaded
      else clearState();
      // Initial check in case the first page's bottom is already in view.
      scheduleCheck();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionInfiniteScroll);
  } else {
    initCollectionInfiniteScroll();
  }

  /* --------------------------------------------------------------------------
     Keep the back-to-top button clear of the bottom promotion bar

     The "Unlock 10% OFF" bar is app-injected as a fixed element pinned to the
     bottom of the viewport. The theme's scroll-to-top button is pinned
     bottom-right too, so on mobile the bar runs the full width and lands
     directly on top of the button - the arrow can't be seen or tapped.

     Two different apps have supplied that bar: the original promotion bar
     (#PBarNextFrameWrapper) and the Klaviyo teaser that replaced it, whose
     class carries a per-form hash (kl-teaser-XXXXXX), so it is matched on the
     prefix rather than the exact class. Match both - either may be live.

     Only a bar that actually sits in the button's column counts: on desktop the
     Klaviyo teaser docks bottom-LEFT at ~184px wide, nowhere near the
     bottom-right button, and must not push it up.

     Measure whichever bottom bar is present and publish its height as
     --promo-bar-height; theme.liquid adds that to the button's offset. The bar
     is injected asynchronously and can be dismissed or resized, so watch for
     both. Falls back to 0px, which is the stock position.
     -------------------------------------------------------------------------- */
  function initPromoBarOffset() {
    var BAR_SELECTOR = '#PBarNextFrameWrapper, [class*="kl-teaser-"]';
    var root = document.documentElement;
    var observed = null;
    var scheduled = false;
    var resizeObserver = window.ResizeObserver ? new ResizeObserver(measure) : null;

    function findBar(buttonRect) {
      var bars = document.querySelectorAll(BAR_SELECTOR);

      for (var i = 0; i < bars.length; i++) {
        var rect = bars[i].getBoundingClientRect();

        // Count it only while it is visible, docked to the bottom, and
        // overlapping the button horizontally. Testing the overlap rather than
        // the bar's width keeps a bar parked in the opposite corner from
        // shifting the button. Horizontal-only, so lifting the button out of
        // the bar can't feed back and un-detect it.
        if (
          rect.height > 0 &&
          rect.bottom >= window.innerHeight - 2 &&
          rect.right > buttonRect.left &&
          rect.left < buttonRect.right
        ) {
          return bars[i];
        }
      }

      return null;
    }

    function measure() {
      var button = document.querySelector('[data-scroll-top-button]');
      if (!button) return;

      var bar = findBar(button.getBoundingClientRect());
      var height = bar ? Math.round(bar.getBoundingClientRect().height) : 0;

      root.style.setProperty('--promo-bar-height', height + 'px');

      // Re-measure when the bar itself changes size (the app resizes it on load).
      if (resizeObserver && bar !== observed) {
        if (observed) resizeObserver.unobserve(observed);
        observed = bar;
        if (bar) resizeObserver.observe(bar);
      }
    }

    // The bar is injected well after load and a few levels deep, so the whole
    // tree has to be watched, not just body's own children. Coalesce the bursts
    // into one measure so infinite scroll's inserts stay cheap. A timer rather
    // than requestAnimationFrame: rAF is frozen while the tab is backgrounded,
    // so the offset would only land after the tab was looked at again.
    function scheduleMeasure() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        measure();
      }, 100);
    }

    measure();

    if (window.MutationObserver) {
      new MutationObserver(scheduleMeasure).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    window.addEventListener('resize', scheduleMeasure);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoBarOffset);
  } else {
    initPromoBarOffset();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
